// import React, { useState, useEffect } from "react";
// import styled from "styled-components";

// const Container = styled.div`
//   padding: 20px;
//   text-align: center;
//   @media (max-width: 576px) {
//     padding: 0px;
//   }
// `;

// const Grid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(4, 80px);
//   gap: 10px;
//   justify-content: center;

//   @media (max-width: 600px) {
//     grid-template-columns: repeat(4, 60px);
//     gap: 5px;
//   }
// `;

// const SlotBox = styled.div`
//   width: 80px;
//   height: 80px;
//   background: ${(props) =>
//         props.status === "Available" ? "#06a52b" : "#ef4766"};
//   color: white;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border-radius: 8px;
//   cursor: ${(props) => (props.status === "Booked" ? "not-allowed" : "pointer")};
//   opacity: ${(props) => (props.status === "Booked" ? 0.6 : 1)};

//   @media (max-width: 576px) {
//     width: 60px;
//     height: 60px;
//   }
// `;

// const Button = styled.button`
//   margin: 5px;
//   padding: 10px 20px;
//   border: none;
//   border-radius: 6px;
//   background: #ef4766;
//   color: white;
//   font-weight: bold;
//   cursor: pointer;
// `;

// const PlanCard = styled.div`
//   margin-top: 20px;
//   display: inline-block;
//   text-align: left;
//   padding: 20px;
//   border-radius: 10px;
//   background: #f4f4f4;
//   min-width: 260px;
// `;

// const Title = styled.h3`
//   margin-top: 0;
//   color: #ef4766;
// `;

// const FormContainer = styled.div`
//   max-width: 900px;
//   width: 95%;
//   margin: 30px auto;
//   background-color: #f4f4f4;
//   padding: 20px;
//   border-radius: 10px;

//   h5 {
//     text-align: center;
//     margin-bottom: 20px;
//     font-size: 20px;
//   }

//   @media (max-width: 480px) {
//     padding: 15px;
//   }
// `;

// const FormGrid = styled.div`
//   display: grid;
//   grid-template-columns: 1fr;
//   gap: 15px;

//   /* Tablet */
//   @media (min-width: 600px) {
//     grid-template-columns: 1fr 1fr;
//   }

//   /* Mobile */
//   @media (max-width: 599px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const InputGroup = styled.div`
//   display: flex;
//   flex-direction: column;

//   label {
//     margin-bottom: 5px;
//     font-size: 14px;
//     font-weight: 500;
//   }
// `;

// const Input = styled.input`
//   padding: 10px;
//   border-radius: 6px;
//   border: 1px solid #ccc;
//   font-size: 14px;
//   width: 100%;
//   box-sizing: border-box;

//   &:focus {
//     outline: none;
//     border-color: #ef4766;
//   }
// `;

// const TextArea = styled.textarea`
//   padding: 10px;
//   border-radius: 6px;
//   border: 1px solid #ccc;
//   font-size: 14px;
//   width: 100%;
//   box-sizing: border-box;
//   resize: vertical;

//   &:focus {
//     outline: none;
//     border-color: #ef4766;
//   }
// `;

// const SubmitButton = styled.button`
//   margin-top: 20px;
//   padding: 12px;
//   width: 100%;
//   background: #ef4766;
//   color: white;
//   border: none;
//   border-radius: 6px;
//   font-weight: bold;
//   font-size: 15px;
//   cursor: pointer;
//   transition: 0.3s;

//   &:hover {
//     background: #d63b58;
//   }

//   @media (max-width: 480px) {
//     padding: 10px;
//     font-size: 14px;
//   }
// `;

// const SelectSlot = () => {
//     const [slots, setSlots] = useState([]);
//     const [selectedSlot, setSelectedSlot] = useState(null);
//     const [planData, setPlanData] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [showForm, setShowForm] = useState(false);

//     const merchantData = JSON.parse(localStorage.getItem("merchantLogin"));

//     const monthsOptions = [3, 6, 9, 12];

//     const [formData, setFormData] = useState({
//         CouponName: "",
//         Title: "",
//         Description: "",
//         CouponCode: "",
//         CouponImage: null,
//     });

//     useEffect(() => {
//         const fetchSlots = async () => {
//             try {
//                 const res = await fetch(
//                     "https://api.bakpoket.com/api/PremiumCoupons/slots-grid"
//                 );
//                 const data = await res.json();
//                 setSlots(data);
//             } catch (error) {
//                 console.error(error);
//             }
//         };

//         fetchSlots();
//     }, []);

//     const handleSlotClick = (slot) => {
//         if (slot.status === "Booked") return;
//         setSelectedSlot(slot.slotId);
//         setPlanData(null);
//     };

//     const handleMonthClick = async (months) => {
//         setLoading(true);

//         try {
//             const res = await fetch(
//                 `https://api.bakpoket.com/api/PremiumCoupons/price?months=${months}&slotId=${selectedSlot}`
//             );

//             const data = await res.json();
//             setPlanData(data);
//         } catch (error) {
//             console.error(error);
//         } finally {
//             setLoading(false);
//         }
//     };



//     const handleChange = (e) => {
//         setFormData({
//             ...formData,
//             [e.target.name]: e.target.value,
//         });
//     };

//     const handleImage = (e) => {
//         setFormData({
//             ...formData,
//             CouponImage: e.target.files[0],
//         });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         const startDate = new Date();
//         const endDate = new Date();
//         endDate.setMonth(endDate.getMonth() + planData.months);

//         const data = new FormData();

//         data.append("MerchantId", merchantData?.merchantId);
//         data.append("CouponName", formData.CouponName);
//         data.append("Title", formData.Title);
//         data.append("Description", formData.Description);
//         data.append("CouponCode", formData.CouponCode);
//         data.append("CouponImage", formData.CouponImage);

//         data.append("SlotId", selectedSlot);
//         data.append("Months", planData.months);
//         data.append("PricePerDay", planData.pricePerDay);
//         data.append("TotalDays", planData.days);
//         data.append("BasePrice", planData.basePrice);
//         data.append("DiscountPercent", planData.discountPercent);
//         data.append("FinalPrice", planData.finalPrice);

//         data.append("SlotStartDate", startDate.toISOString());
//         data.append("SlotEndDate", endDate.toISOString());

//         data.append("isApproved", false);

//         try {
//             const res = await fetch(
//                 "https://api.bakpoket.com/api/PremiumCoupons/create",
//                 {
//                     method: "POST",
//                     body: data,
//                 }
//             );

//             const result = await res.json();
//             if (res.status === 200) {
//                 alert("Coupon Uploaded Successfully");
//                 setShowForm(false);
//                 handleBack();
//                 setFormData({
//                     CouponName: "",
//                     Title: "",
//                     Description: "",
//                     CouponCode: "",
//                     CouponImage: null,
//                 })
//             } else {
//                 alert("Upload failed");
//             }
//             console.log(result);

//         } catch (error) {
//             console.error(error);

//         }
//     };


//     const handleBack = () => {
//         setSelectedSlot(null);
//         setPlanData(null);
//     };

//     return (
//         <Container>
//             {!selectedSlot ? (
//                 <>
//                     <h3>Premium Coupons</h3>

//                     <Grid>
//                         {slots.map((slot) => (
//                             <SlotBox
//                                 key={slot.slotId}
//                                 status={slot.status}
//                                 onClick={() => handleSlotClick(slot)}
//                             >
//                                 Slot {slot.slotId}
//                             </SlotBox>
//                         ))}
//                     </Grid>
//                 </>
//             ) : (
//                 <>
//                     {!showForm && (
//                         <>
//                             <div>
//                                 {monthsOptions.map((m) => (
//                                     <Button key={m} onClick={() => handleMonthClick(m)}>
//                                         {m} Months
//                                     </Button>
//                                 ))}
//                                 <Button onClick={handleBack}>Back</Button>
//                             </div>

//                             {loading && <p>Loading...</p>}

//                             {planData && (
//                                 <PlanCard>
//                                     <Title>Plan Details</Title>

//                                     <p>
//                                         <strong>Selected Slot:</strong> {selectedSlot}
//                                     </p>
//                                     <p>
//                                         <strong>Months:</strong> {planData.months}
//                                     </p>
//                                     <p>
//                                         <strong>Days:</strong> {planData.days}
//                                     </p>
//                                     <p>
//                                         <strong>Price Per Day:</strong> {planData.pricePerDay}
//                                     </p>
//                                     <p>
//                                         <strong>Base Price:</strong> {planData.basePrice}
//                                     </p>
//                                     <p>
//                                         <strong>Discount Percent:</strong>{" "}
//                                         {planData.discountPercent}%
//                                     </p>
//                                     <p>
//                                         <strong>Final Price:</strong> {planData.finalPrice}
//                                     </p>

//                                     <Button
//                                         style={{ marginTop: "15px", width: "100%" }}
//                                         onClick={() => setShowForm(true)}
//                                     >
//                                         Continue
//                                     </Button>
//                                 </PlanCard>
//                             )}
//                         </>
//                     )}

//                     {showForm && (
//                         <FormContainer>
//                             <h5>Upload Premium Coupon</h5>

//                             <form onSubmit={handleSubmit}>
//                                 <FormGrid>
//                                     <InputGroup>
//                                         <label style={{ textAlign: 'justify', }}>Coupon Name</label>
//                                         <Input
//                                             name="CouponName"
//                                             value={formData.CouponName}
//                                             onChange={handleChange}
//                                             required
//                                             className="form-controll"
//                                         />
//                                     </InputGroup>

//                                     <InputGroup>
//                                         <label style={{ textAlign: 'justify', }}>Title</label>
//                                         <Input
//                                             name="Title"
//                                             value={formData.Title}
//                                             onChange={handleChange}
//                                             required
//                                         />
//                                     </InputGroup>

//                                     <InputGroup>
//                                         <label style={{ textAlign: 'justify', }}>Coupon Code</label>
//                                         <Input
//                                             name="CouponCode"
//                                             value={formData.CouponCode}
//                                             onChange={handleChange}
//                                             required
//                                         />
//                                     </InputGroup>

//                                     <InputGroup>
//                                         <label style={{ textAlign: 'justify', }}>Coupon Image</label>
//                                         <Input type="file" onChange={handleImage} required />
//                                     </InputGroup>

//                                     <InputGroup style={{ gridColumn: "1 / -1" }}>
//                                         <label style={{ textAlign: 'justify', }}>Description</label>
//                                         <TextArea
//                                             rows="4"
//                                             name="Description"
//                                             value={formData.Description}
//                                             onChange={handleChange}
//                                             required
//                                         />
//                                     </InputGroup>
//                                 </FormGrid>

//                                 <SubmitButton type="submit">Upload Coupon</SubmitButton>
//                                 <SubmitButton type="button" onClick={()=>{handleBack();setShowForm(false)}}>Cancel</SubmitButton>
//                             </form>
//                         </FormContainer>
//                     )}
//                 </>
//             )}
//         </Container>
//     );
// };

// export default SelectSlot;



import axios from "axios";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  padding: 20px;
  text-align: center;
  @media (max-width: 576px) {
    padding: 0px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 80px);
  gap: 10px;
  justify-content: center;

  @media (max-width: 600px) {
    grid-template-columns: repeat(4, 60px);
    gap: 5px;
  }
`;

const SlotBox = styled.div`
  width: 80px;
  height: 80px;
  background: ${(props) =>
        props.status === "Available" ? "#06a52b" : "#ef4766"};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: ${(props) => (props.status === "Booked" ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.status === "Booked" ? 0.6 : 1)};

  @media (max-width: 576px) {
    width: 60px;
    height: 60px;
  }
`;

const Button = styled.button`
  margin: 5px;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  background: #ef4766;
  color: white;
  font-weight: bold;
  cursor: pointer;
`;

const PlanCard = styled.div`
  margin-top: 20px;
  display: inline-block;
  text-align: left;
  padding: 20px;
  border-radius: 10px;
  background: #f4f4f4;
  min-width: 260px;
`;

const Title = styled.h3`
  margin-top: 0;
  color: #ef4766;
`;

const FormContainer = styled.div`
  max-width: 900px;
  width: 95%;
  margin: 30px auto;
  background-color: #f4f4f4;
  padding: 20px;
  border-radius: 10px;

  h5 {
    text-align: center;
    margin-bottom: 20px;
    font-size: 20px;
  }

  @media (max-width: 480px) {
    padding: 15px;
  }
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;

  /* Tablet */
  @media (min-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }

  /* Mobile */
  @media (max-width: 599px) {
    grid-template-columns: 1fr;
  }
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 500;
  }
`;

const Input = styled.input`
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #ef4766;
  }
`;

const TextArea = styled.textarea`
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #ef4766;
  }
`;

const SubmitButton = styled.button`
  margin-top: 20px;
  padding: 12px;
  width: 100%;
  background: #ef4766;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background: #d63b58;
  }

  @media (max-width: 480px) {
    padding: 10px;
    font-size: 14px;
  }
`;

const SelectSlot = () => {
    const [slots, setSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [planData, setPlanData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);

    const [merchantId, setMerchantId] = useState("");
    const [merchantURL, setMerchantURL] = useState("");
    const merchantproductsite = `bakpoket.com/merchantproductsite/${merchantId}`;

    const merchantData = JSON.parse(localStorage.getItem("merchantLogin"));

    const monthsOptions = [3, 6, 9, 12];

    useEffect(()=>{
        console.log('merchantData',merchantData)
    },[])

    // formSubmit
    const handleSubmit = async (e) => {
        if(e) e.preventDefault();

        const startDate = new Date();
        const endDate = new Date();
        endDate.setMonth(endDate.getMonth() + planData.months);

        const data = new FormData();

        data.append("MerchantId", merchantData?.merchantId);
        data.append("CouponName", formData.CouponName);
        data.append("Title", formData.Title);
        data.append("Description", formData.Description);
        data.append("CouponCode", formData.CouponCode);
        data.append("CouponImage", formData.CouponImage);

        data.append("SlotId", selectedSlot);
        data.append("Months", planData.months);
        data.append("PricePerDay", planData.pricePerDay);
        data.append("TotalDays", planData.days);
        data.append("BasePrice", planData.basePrice);
        data.append("DiscountPercent", planData.discountPercent);
        data.append("FinalPrice", planData.finalPrice);

        data.append("SlotStartDate", startDate.toISOString());
        data.append("SlotEndDate", endDate.toISOString());
        data.append("MerchantUrl", merchantURL);


        data.append("isApproved", false);

        try {
            const res = await fetch(
                "https://api.bakpoket.com/api/PremiumCoupons/create",
                {
                    method: "POST",
                    body: data,
                }
            );

            const result = await res.json();
            if (res.status === 200) {
                alert("Coupon Uploaded Successfully");
                setShowForm(false);
                handleBack();
                setFormData({
                    CouponName: "",
                    Title: "",
                    Description: "",
                    CouponCode: "",
                    CouponImage: null,
                })
            } else {
                alert("Upload failed");
            }
            console.log(result);

        } catch (error) {
            console.error(error);

        }
    };

    // Payment
    const [razorpayLoaded, setRazorpayLoaded] = useState(false);
    const location = useLocation();
    const [amountInPaise, setAmountInPaise] = useState(0);
    const mobile = location.state?.mobile || '';
    useEffect(()=>{
        if(planData){
            const amount = planData.finalPrice; // default ₹2 if not passed
            setAmountInPaise(amount * 100)
        }
    },[planData])
    

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.onload = () => setRazorpayLoaded(true);
        script.onerror = () => console.error('Failed to load Razorpay script');
        document.body.appendChild(script);
    }, []);



    const handleClick = () => {
        if (!razorpayLoaded || typeof window.Razorpay === 'undefined') {
            alert('Razorpay SDK failed to load. Please try again later.');
            return;
        }

        const merchantData = JSON.parse(localStorage.getItem("merchantLogin"));

        const options = {
            key: 'rzp_live_DFlbGU4ZrBz1UT',
            amount: amountInPaise,
            currency: 'INR',
            name: 'BakPoket Pvt Ltd',
            description: 'Dynamic Payment',
            image: 'https://yourcdn.com/logo.png',
            order_id: '',
            handler: function (response) {
                alert('Payment Successful!');
                handleSubmit()
                console.log(response);
            },
            prefill: {
                name: merchantData.merchantName,
                email: merchantData.email,
                ontact: merchantData?.mobileNumber,
            },
            notes: {
                address: 'BakPoket HQ',
            },
            theme: {
                color: '#ef4766',
            },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    };


    const [formData, setFormData] = useState({
        CouponName: "",
        Title: "",
        Description: "",
        CouponCode: "",
        CouponImage: null,
    });

    useEffect(() => {
        const fetchSlots = async () => {
            try {
                const res = await fetch(
                    "https://api.bakpoket.com/api/PremiumCoupons/slots-grid"
                );
                const data = await res.json();
                setSlots(data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchSlots();
    }, []);

    const handleSlotClick = (slot) => {
        if (slot.status === "Booked") return;
        setSelectedSlot(slot.slotId);
        setPlanData(null);
    };

    const handleMonthClick = async (months) => {
        setLoading(true);

        try {
            const res = await fetch(
                `https://api.bakpoket.com/api/PremiumCoupons/price?months=${months}&slotId=${selectedSlot}`
            );

            const data = await res.json();
            setPlanData(data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };



    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleImage = (e) => {
        setFormData({
            ...formData,
            CouponImage: e.target.files[0],
        });
    };






    useEffect(() => {
    const merchantData = localStorage.getItem("merchantLogin");
    const googleLogin = localStorage.getItem('googleLogin');
    if (googleLogin === "false") {
      if (merchantData) {
        const parsedData = JSON.parse(merchantData);
        const merchantIdVal = parsedData.merchantId || parsedData.id;
        if (merchantIdVal) setMerchantId(merchantIdVal.toString());
      }
    } else {
      const merchantDashboardLogin = localStorage.getItem("merchantDashboardLogin");
      if (merchantDashboardLogin) {
        const parsedData = JSON.parse(merchantDashboardLogin);
        const merchantIdVal = parsedData.merchantId || parsedData.id;
        if (merchantIdVal) setMerchantId(merchantIdVal.toString());
      }
    }
  }, []);

  useEffect(() => {
    if (merchantId) {
      axios.get(`https://api.bakpoket.com/api/MerchantDetails/${merchantId}`)
        .then((res) => {
          setMerchantURL(
            res.data.merchatSiteUrl && res.data.merchatSiteUrl.trim() !== ""
              ? res.data.merchatSiteUrl
              : merchantproductsite
          );
        })
        .catch((err) => console.error(err));
    }
  }, [merchantId]);



    const handleBack = () => {
        setSelectedSlot(null);
        setPlanData(null);
        setFormData({
                    CouponName: "",
                    Title: "",
                    Description: "",
                    CouponCode: "",
                    CouponImage: null,
                })
    };

    return (
        <Container>
            {!selectedSlot ? (
                <>
                    <h3>Premium Coupons</h3>

                    <Grid>
                        {slots.map((slot) => (
                            <SlotBox
                                key={slot.slotId}
                                status={slot.status}
                                onClick={() => handleSlotClick(slot)}
                            >
                                Slot {slot.slotId}
                            </SlotBox>
                        ))}
                    </Grid>
                </>
            ) : (
                <>
                    {!showForm && (
                        <>
                            <div>
                                {monthsOptions.map((m) => (
                                    <Button key={m} onClick={() => handleMonthClick(m)}>
                                        {m} Months
                                    </Button>
                                ))}
                                <Button onClick={handleBack}>Back</Button>
                            </div>

                            {loading && <p>Loading...</p>}

                            {planData && (
                                <PlanCard>
                                    <Title>Plan Details</Title>

                                    <p>
                                        <strong>Selected Slot:</strong> {selectedSlot}
                                    </p>
                                    <p>
                                        <strong>Months:</strong> {planData.months}
                                    </p>
                                    <p>
                                        <strong>Days:</strong> {planData.days}
                                    </p>
                                    <p>
                                        <strong>Price Per Day:</strong> {planData.pricePerDay}
                                    </p>
                                    <p>
                                        <strong>Base Price:</strong> {planData.basePrice}
                                    </p>
                                    <p>
                                        <strong>Discount Percent:</strong>{" "}
                                        {planData.discountPercent}%
                                    </p>
                                    <p>
                                        <strong>Final Price:</strong> {planData.finalPrice}
                                    </p>

                                    <Button
                                        style={{ marginTop: "15px", width: "100%" }}
                                        onClick={() => setShowForm(true)}
                                    >
                                        Continue
                                    </Button>
                                </PlanCard>
                            )}
                        </>
                    )}

                    {showForm && (
                        <FormContainer>
                            <h5>Upload Premium Coupon</h5>

                            {/* <form onSubmit={(e)=>{handleSubmit(e)}}> */}
                            <form onSubmit={(e)=>{e.preventDefault();handleClick()}}>
                                <FormGrid>
                                    <InputGroup>
                                        <label style={{ textAlign: 'justify', }}>Coupon Name</label>
                                        <Input
                                            name="CouponName"
                                            value={formData.CouponName}
                                            onChange={handleChange}
                                            required
                                            className="form-controll"
                                        />
                                    </InputGroup>

                                    <InputGroup>
                                        <label style={{ textAlign: 'justify', }}>Title</label>
                                        <Input
                                            name="Title"
                                            value={formData.Title}
                                            onChange={handleChange}
                                            required
                                        />
                                    </InputGroup>

                                    <InputGroup>
                                        <label style={{ textAlign: 'justify', }}>Coupon Code</label>
                                        <Input
                                            name="CouponCode"
                                            value={formData.CouponCode}
                                            onChange={handleChange}
                                            required
                                        />
                                    </InputGroup>

                                    <InputGroup>
                                        <label style={{ textAlign: 'justify', }}>Coupon Image</label>
                                        <Input type="file" onChange={handleImage} required />
                                    </InputGroup>

                                    <InputGroup style={{ gridColumn: "1 / -1" }}>
                                        <label style={{ textAlign: 'justify', }}>Description</label>
                                        <TextArea
                                            rows="4"
                                            name="Description"
                                            value={formData.Description}
                                            onChange={handleChange}
                                            required
                                        />
                                    </InputGroup>
                                </FormGrid>

                                <SubmitButton type="submit">Upload Coupon</SubmitButton>
                                <SubmitButton type="button" onClick={() => { handleBack(); setShowForm(false) }}>Cancel</SubmitButton>
                            </form>
                        </FormContainer>
                    )}
                </>
            )}
        </Container>
    );
};

export default SelectSlot;



